<template>
    <div class="footer">
        <div class="container">
            <div class="code_img">
                <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/hr/pic_QR%20code%402x.png"/>
                <p>易猎云公众号</p>
            </div>
            <div class="iconlist">
                <img class="logo" src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/logo_yilieyun%402x.png"/>
                <nav class="nav-links">
                    <span @click="gotohome">首页</span>
                    <span @click="gotoabout">公司介绍</span>
                    <a href="https://help.yilieyun.cn" target="_blank">帮助</a>
                </nav>
            </div>
            <div class="tel">
                <img src="https://img.yilieyun.com/oss/ylyh5officialWebimagese/icon2_telephone@2x.png"/>
                <span>400-0588-036</span>
            </div>
            <div class="copyright">
                <p>© 2018-2024 易猎云（海南）科技有限公司版权所有<br/> <a href="https://beian.miit.gov.cn/" target="view_window">琼ICP备2021005894号-1</a></p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'footers',
    data(){
        return{
             routeData: {}
        }
    },
    mounted(){
        if(Object.keys(this.$route.query).length) {
            this.routeData = this.$route.query
        }
    },
    methods:{
        gotohome(){
            this.$router.push('/home');
            document.documentElement.scrollTop = 0
        },
        gotoapply(){
            this.$router.push({path:'/apply',query:this.routeData});
            document.documentElement.scrollTop = 0
        },
        gotoabout(){
            this.$router.push('/about');
            document.documentElement.scrollTop = 0
        }

    }
}
</script>
<style lang="less" scoped>
.footer{
    .container{
        position: relative;
        width: 100%;
        height: 1.34rem;
        background: #1F2532;
        padding-top: .1rem;
        .code_img{
            position: absolute;
            width: .54rem;
            height: .60rem;
            right: .1rem;
            top: .5rem;
            img{
                margin-top: -.85rem;
            }
            p{
                font-size: .08rem;
                color: #ffffff;
                margin-top: -.62rem;
                text-align: center;

            }
        }
        .iconlist{
            display: flex;
            align-items: center;
            width: 100%;
            height: .4rem;
            padding: 0 .27rem;
            box-sizing: border-box;
            .logo{
                width: .69rem;
                height: .19rem;
                flex-shrink: 0;
            }
            .nav-links{
                display: flex;
                align-items: center;
                flex: 1;
                margin-left: .31rem;
                gap: .24rem;
                span, a{
                    font-size: .08rem;
                    color: #ffffff;
                    line-height: 1;
                    white-space: nowrap;
                    text-decoration: none;
                }
            }
        }
        .tel{
            position: relative;
            width: 100%;
            height: .14rem;
            margin-top: .1rem;
            img{
                position: absolute;
                width: .12rem;
                height: .14rem;
                left: .31rem;
            }
            span{
                position: absolute;
                font-size: .1rem;
                color: #ffffff;
                left: .47rem;
                line-height: .14rem;
            }
        }
        .copyright{
            width: 100%;
            height: .32rem;
            margin-top: .24rem;

            p{
                font-size: .08rem;
                color: #ffffff;
                text-align: center;
                line-height: .16rem;
            }
            a{
                color: #ffffff;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/views/footer/index.vue